module.exports = __webpack_public_path__ + "static/media/riskbanner@3x.0ea26102.png";